var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval21B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 42",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Oval-2-1-B_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M34 14c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 42 0 35.732 0 28s6.268-14 14-14h20ZM34 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M39 6c0-2.046-2.06-4-5-4s-5 1.954-5 4v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M14 11c-3.314 0-6-2.239-6-5s2.686-5 6-5 6 2.239 6 5-2.686 5-6 5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M19 6c0-2.046-2.06-4-5-4S9 3.954 9 6v1a1 1 0 1 1-2 0V6c0-3.477 3.313-6 7-6 3.688 0 7 2.523 7 6v1a1 1 0 0 1-2 0V6Z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Oval-2-1-B_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h48v42H0z"
})))));
SvgOval21B.viewBox = '0 0 48 42';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval21B);
export default ForwardRef;